import React, { useEffect } from "react";
import "./OnlineQuranRecitation.css";
import CourseCard from "../../../Components/AllCourseCard/CourseCard";
import PricingCards from "../../Home/PricingCards";
import CourseFeatures from "../../../Components/CourseFeatures/CourseFeatures";

const OnlineQuranRecitation = () => {
  useEffect(() => {
    document.title = "Online Quran Recitation";
  }, []);
  const courseBenefits = [
    {
      heading: "Online Quran Recitation Course",
      content: `In a world teeming with digital learning platforms, the quest for 
        spiritual education has also found its sanctuary online. Among these havens stands the prestigious 
        AL-NISA Quran Academy, a beacon of divine knowledge illuminating the path for those seeking to immerse 
        themselves in the sacred teachings of the Quran through an Online Quran Recitation Course.`,
    },
    {
      heading: "A Journey Towards Spiritual Elevation",
      content: `Online Quran recitation is not merely an act of reading; it’s an art 
        that involves melodious voice modulation, correct pronunciation, and understanding the depth of Allah’s words. 
        The Online Quran Recitation Course at AL-NISA Quran Academy offers a comprehensive curriculum designed to nurture 
        these skills in students of all ages.`,
    },
    {
      heading: "Explore the Best Quran Recitation Course Online",
      content: `The academy’s unique offering, Best Quran Recitation Course Online, 
        stands out for its meticulously structured syllabus that combines traditional teachings with modern pedagogical methods. 
        This program ensures that each student develops a profound connection with the Quran, enriching their recitation and comprehension.`,
    },
    {
      heading: "Quran Recitation Online Course",
      content: `AL-NISA Quran Academy prides itself on making Quranic education accessible to all. 
        The Quran Recitation Online Course breaks geographical barriers, enabling learners from every corner of the globe to 
        embark on this sacred journey.`,
    },
    {
      heading: "Why Choose AL-NISA Academy?",
      content: `Choosing AL-NISA – Online Quran Recitation Course Academy means embarking on a 
        journey of self-discovery and spiritual growth under the mentorship of expert tutors who are not just masters of recitation 
        but embody the essence of Islamic teachings.`,
    },
    {
      heading: "Embark on Your Divine Journey Today",
      content: `AL-NISA Online Academy invites you to join its community of seekers, learners, and educators 
        on this beautiful path of Quranic enlightenment. With a curriculum designed for all levels of proficiency, 
        the academy is your gateway to discovering the unbounded grace and wisdom of Allah’s words.`,
    },
  ];

  const courseContent = [
    [
      "Quranic Phonetics",
      "Quran Recitation Techniques",
      "Recitation of Short Surahs",
      "Recitation of Long Surahs",
      "Arabic Diacritics",
      "Letters Forms",
    ],
    [
      "Intro to Tajweed Rules",
      "Characteristics of the Quranic writing",
      "The Tanween",
      "The Shaddah",
      "Hamzatul-Wassl",
    ],
  ];

  return (
    <>
      {/* Header Section */}
      <div className="container-fluid bg-img-2 text-center">
        <h2 className="main-heading">Online Quran Recitation</h2>
      </div>

      {/* Main Content Section */}
      <div className="container main-content mt-5">
        {courseBenefits.map((benefit, index) => (
          <div key={index} className="content-block">
            <h2 className="content-heading h2-main">{benefit.heading}</h2>
            <p className="content-text p-main">{benefit.content}</p>
          </div>
        ))}
      </div>

      {/* Course Content Section */}
      <div className="container">
        <h2 className="-main text-center mt-4">
          In the Quran Recitation Course, you’ll learn:
        </h2>
        <div className="row">
          {courseContent.map((list, index) => (
            <div key={index} className="col-sm-12 col-lg-6">
              <ul className="list-group lists">
                {list.map((item, idx) => (
                  <li key={idx} className="list-item lists">
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Additional Components */}
      <CourseFeatures />
      <CourseCard />
      <PricingCards />
    </>
  );
};

export default OnlineQuranRecitation;

